module.exports = __webpack_public_path__ + "img/c2.7729f97c.png";